<script>
  import { layoutMethods,billsPaymentMethods, exportMethods,erpFixMessages} from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from 'sweetalert2';
  /**
   * Bills Payment component
   */
  export default {
    page: {
      title: "Bills Payment"
    },
    data() {
      return {
        title: "Bills Payment",
        searchValue: {
          searchField: null,
          search: "",
          dateRange: null,
          sort: 'id',
          orderDesc: true,
          status: null,
          page: 1,
          rows: 10,
          provider: null
        },
        searchList: [
          { text: "Search All", value: null },
          { text: "Biller Name", value: "biller_name" },
          { text: "Provider Name", value: "provider_name" }
        ],
        statusList: [
          { text: 'All', value: null },
          { text: 'Active', value: 1 },
          { text: 'Inactive', value: 0 },
        ],
        fields: [
          {key: "provider_name",sortable: true},
          {key: "biller_name",sortable: true},
          {key: "image",sortable: false},
          {key: "status",sortable: true},
          {key: "category_description", label:"category", sortable: true},
          {key: "description",sortable: true},
          {key: "service_fee",sortable: true},
          {key: "convenience_fee",label:"Supplier Convenience Fee",sortable: true},
          {key: "peddlr_conve_fee",label:"Peddlr Convenience Fee",sortable: true},
          {key: "final_conve_fee",label:"Final Convenience Fee",sortable: true},
          {key: "merchant_comm_fee",label:"Merchant Share",sortable: true},
          {key: "peddlr_share_fee",label:"Peddlr Share",sortable: true},
          {key: "seller_comm_fee",label:"Store Commission",sortable: true},
        ],
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        rangeOptions: {
          mode: "range",
        },
        sortBy: "value",
        sortDesc: false,
        tbl_data :[],
        total_count:0,
        providerList: [
          { text: 'All', value: null }
        ],
        bayadCenterApiModal: false,
        bayadCenterData:{}
      };
    },
    components:{
      flatPickr,
    },
    computed: {
      ...erpFixMessages
    },
    methods: {
      ...layoutMethods,
      ...billsPaymentMethods,
      ...exportMethods,
      async onExport(){
        await this.onSearch("reset");
        if(this.total_count ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        // var search_value_holder = this.searchValue;
        let params = Object.assign(
          // this.searchValue,
          {
            module: 'bills_payment',
            email: JSON.parse(localStorage.getItem('userData')).email,
            dateRange: this.searchValue.dateRange,
            orderDesc: this.searchValue.orderDesc,
            search: this.searchValue.search,
            searchField: this.searchValue.searchField,
            sort: this.searchValue.sort,
            provider: this.searchValue.provider,
            status: this.searchValue.status
          });

        // delete params.page;
        // delete params.rows;
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
          console.log("value:",this.searchValue,params)
          // this.searchValue = search_value_holder;
      },
      async onSearch(state = ''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        // this.tbl_data=[];
        await this.actionBillsPayment({
            action: "list",
            body: this.searchValue
        })
        .then((res) => {
          console.log(res);
          this.tbl_data = res["message"]["rows"];
          this.total_count = res["message"]["pageInfo"]["total"];
        }).catch((e)=>{
          console.log("error while getting bills payment list",e);
        });
      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        this.onSearch('reset');
      },
      onDisplayChange(){
        console.log(this.total_count,this.searchValue.rows,this.tbl_data.length,(this.tbl_data.length < this.total_count && this.tbl_data.length != this.searchValue.rows));
        if(
          (this.tbl_data.length < this.total_count && this.tbl_data.length != this.searchValue.rows) || // condition for incrementing display per page
          (this.tbl_data.length == this.total_count && this.searchValue.rows < this.tbl_data.length) // condition for decreasing display per page
          ){
          this.searchValue.page=1;
          this.onSearch('reset')
        }
      },
      async providerLst(){
        await this.actionBillsPayment({
            action: "provider-list",
            body: {}
        })
        .then((res) => {
          console.log(res);
          for(let r of res["message"]["rows"]){
            this.providerList.push({ text: r["provider_name"], value: r["provider_code"] });
          }
        }).catch((e)=>{
          console.log("error while getting bills provider list",e);
        }); 
      },
      async ecpay(){
        await this.actionBillsPayment({
            action: "ecpay-cron",
            body: {}
        })
        .then((res) => {
          console.log(JSON.stringify(res));
        }).catch((e)=>{
          console.log("error while getting bills provider list",JSON.stringify(e));
        });
      },
      async bayadCenter(action = "modal"){
        switch (action) {
          case "modal":
            this.bayadCenterApiModal = true;
            break;
          case "billers":
            await this.actionBillsPayment({
                action: "get-bayad-center-billers",
                body: {}
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "biller-details":
            await this.actionBillsPayment({
                action: "get-bayad-center-biller-details",
                body: {
                  biller_code: "MECOR"
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "biller-account":
            await this.actionBillsPayment({
                action: "get-bayad-center-biller-account",
                body: {
                  "biller_code": "MECOR",
                  "acct_number": "0002191491",
                  "paymentMethod": "CASH",
                  "amount": "300.00",
                  "otherCharges": "0.00"
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "biller-payment":
            await this.actionBillsPayment({
                action: "get-bayad-center-biller-payment",
                body: {
                  "biller_code": "MECOR",
                  "clientReference": "b43a28e1-e6e6-41bd-8f03-373b2855555",
                  "validationNumber": "d529a73d-0c96-4a86-865f-d133daaba732"
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "biller-payment-inquiry":
            await this.actionBillsPayment({
                action: "get-bayad-center-biller-payment-inquiry",
                body: {
                  "biller_code": "MECOR",
                  "clientReference": "b43a28e1-e6e6-41bd-8f03-373b2855555"
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "biller-fees":
            await this.actionBillsPayment({
                action: "get-bayad-center-biller-fees",
                body: {
                  biller_code: "MECOR"
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "biller-wallet":
            await this.actionBillsPayment({
                action: "get-bayad-center-wallet",
                body: {
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
          case "cron":
            await this.actionBillsPayment({
                action: "cron-bayad-center-billers",
                body: {
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;

          case "cron-fees":
            await this.actionBillsPayment({
                action: "cron-bayad-center-billers-fees",
                body: {
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;

          case "cron-params":
            await this.actionBillsPayment({
                action: "cron-bayad-center-billers-params",
                body: {
                }
            })
            .then((res) => {
              console.log(JSON.stringify(res));
            }).catch((e)=>{
              console.log("ERROR BAYAD CENTER",JSON.stringify(e));
            });
            break;
        
          default:
            this.bayadCenterApiModal = true;
            break;
        }
      },
      visibleTestButton(){
        try {
          // console.log(":: visibleTestButton ::");
          var qa = ["john.arquitola@peddlr.ph","jay.zapanta@peddlr.ph","rafael.delrosario@peddlr.ph"]
          // console.log(JSON.parse(localStorage.getItem('userData')).email, qa);
          if(qa.includes(JSON.parse(localStorage.getItem('userData')).email)){
            return true;
          }else{
            return false;
          } 
        } catch (error) {
          console.log("ERROR",JSON.stringify(error));
          return false
        }
      },
      addBiller(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Bills Payment Form", params: { id: 0}
          }
        );
      },
    },
    async mounted(){
      this.changeTitle({title: 'Bills Payment'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Bills Payment', to: { name: 'Bills Payment'} }
        ]
      });
      await this.onSearch();
      await this.providerLst();
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{total_count}}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <a class="btn btn-primary me-2" @click="addBiller">
                  <i class="uil uil-plus me-1"></i> Create Biller
                </a>
                <button class="btn btn-secondary me-2" @click="bayadCenter" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; bayadCenter
                </button>
                <button class="btn btn-secondary me-2" @click="ecpay" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; ecpay
                </button>
                <button class="btn btn-secondary" @click="onSearch">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <div class="col-md-12 mt-3"></div>
              <!-- Search and button -->
              <div class="col-md-3 ta-right">
                <b-form-group description="Search Keyword">
                  <form class="d-flex" @submit.prevent="onSearch('reset')">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchList"
                      ></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input
                        class="rounded-0"
                        v-model="searchValue.search"
                      ></b-form-input>
                    </b-input-group>
                  </form>
                </b-form-group>
              </div>
              <div class="col-md-2 ta-right">
                <b-form-group label-for="reward-status" description="Filter by status">
                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                    id="reward-status"
                    v-model="searchValue.status"
                    :options="statusList"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-2 ta-right">
                <b-form-group label-for="reward-status" description="Filter by Provider">
                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                    id="reward-status"
                    v-model="searchValue.provider"
                    :options="providerList"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-5">
                <div
                  class="
                    d-flex
                    flex-wrap
                    align-items-start
                    mt-2 mt-md-0
                    gap-2
                    mb-3 ta-right
                  "
                >
                  <b-form-group description="Filter by date added" v-if="false">
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control"
                      style="width: fit-content"
                    ></flat-pickr>
                  </b-form-group>
                  <a class="btn btn-primary h-fit" @click="onSearch('reset')">
                    <i class='bx bx-search bx-fw'></i>Search
                  </a>
                <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                  <i class="uil uil-export me-1"></i>
                  Export
                </a>
                </div>
              </div>
            </div>
            <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap text-capitalize">
                <b-table
                  :items="tbl_data"
                  :fields="fields"
                  responsive="sm"
                  :current-page="searchValue.page"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSort"
                >
                  <template #cell(image)="data">
                      <img
                      :src="data.item.image==null?'x':data.item.image"
                      alt="Biller Image"
                      @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                      class="border-end img-fluid border-0 rounded-start img-cover"
                      style="width: 60px;"
                      />
                  </template>
                  <template #cell(status)="data">
                      <span class="text-success" v-if="data.item.status == 1">
                        Active
                      </span>
                      <span class="text-danger" v-else>
                        Inactive
                      </span>
                  </template>
                  <template #cell(biller_name)="data">
                    <router-link :to="{ name: 'Bills Payment Form', params: { id: data.item.id }}">
                     <span v-bind:title='data.item.biller_name'>{{data.item.biller_name | truncator(20,'...')}}</span>
                    </router-link>
                  </template>
                  <template #cell(description)="data">
                    <p v-bind:title='data.item.description'>{{data.item.description | truncator(20,'...')}}</p>
                  </template>
                  <template #cell(merchant_comm_fee)="data">
                    <p class="text-center">₱ {{data.item.merchant_comm_fee | toCurrency}}</p>
                  </template>
                  <template #cell(convenience_fee)="data">
                    <p class="text-center">₱ {{data.item.convenience_fee == null ? 0:data.item.convenience_fee | toCurrency}}</p>
                  </template>
                  <template #cell(service_fee)="data">
                    <p class="text-center">₱ {{data.item.service_fee | toCurrency}}</p>
                  </template>
                  <template #cell(peddlr_conve_fee)="data">
                    <p class="text-center">₱ {{data.item.peddlr_conve_fee | toCurrency}}</p>
                  </template>
                  <template #cell(final_conve_fee)="data">
                    <p class="text-center">₱ {{data.item.final_conve_fee | toCurrency}}</p>
                  </template>
                  <template #cell(peddlr_share_fee)="data">
                    <p class="text-center">₱ {{data.item.peddlr_share_fee | toCurrency}}</p>
                  </template>
                  <template #cell(seller_comm_fee)="data">
                    <p class="text-center">₱ {{data.item.seller_comm_fee | toCurrency}}</p>
                  </template>

                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="total_count == 0">
              <!-- topupLogsTotalRows == 0 -->
              <span>No data to display.</span>
            </div>
            <div class="row" v-if="total_count > 0">
              <div class="col">
                <div class="form-group row pull-left">
                  <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                  <div class="col-sm-6">
                    <b-form-group label-for="display-record">
                      <b-form-select class="form-select shadow-none w-fit"
                        id="display-record"
                        v-model="searchValue.rows"
                        :options="pageOptions"
                        @change="onDisplayChange()"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="
                    dataTables_paginate
                    paging_simple_numbers
                    float-end
                  "
                >
                  <b-pagination
                    v-if="total_count != 0 && total_count > searchValue.rows"
                    class="pagination-rounded"
                    v-model="searchValue.page"
                    :total-rows="total_count"
                    @input="onSearch()"
                    :per-page="searchValue.rows"
                  ></b-pagination>
                </div>
              </div>
            </div>

            <b-modal
              id="modalBayadCenterAPI" 
              title="BAYAD CENTER API TESTING" 
              size="md" 
              centered 
              hide-footer 
              hide-header-close
              v-model="bayadCenterApiModal"
              >
                <button class="btn btn-secondary me-2" @click="bayadCenter('billers')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; billers
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('biller-details')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; biller details
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('biller-account')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; biller account
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('biller-payment')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; biller payment
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('biller-payment-inquiry')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; biller payment inquiry
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('biller-fees')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; biller fees
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('biller-wallet')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; biller wallet
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('cron')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; cron
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('cron-fees')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; cron fees
                </button>

                <button class="btn btn-secondary me-2" @click="bayadCenter('cron-params')" v-if="visibleTestButton()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; cron params
                </button>
              </b-modal>
            
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>